import { render, staticRenderFns } from "./ComplaintUndertakeView.vue?vue&type=template&id=c1730c10"
import script from "./ComplaintUndertakeView.vue?vue&type=script&lang=js"
export * from "./ComplaintUndertakeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports